import { createResourceBuilder } from '../resource';
import { EResourceMethod } from '../models/IPermission';

export const productPackageResources = {
  getPackages: createResourceBuilder('/drmrust/v2.1/admin/products/packages', EResourceMethod.Get),
  createPackage: createResourceBuilder('/drmrust/v2.1/admin/products/packages', EResourceMethod.Post),
  updatePackage: createResourceBuilder(
    '/drmrust/v2.1/admin/products/packages/:package_id',
    EResourceMethod.Put,
    (package_id: string) => ({ package_id })
  ),
  deletePackage: createResourceBuilder(
    '/drmrust/v2.1/admin/products/packages/:package_id',
    EResourceMethod.Delete,
    (package_id: string) => ({ package_id })
  ),
};
